module.exports = __webpack_public_path__ + "static/media/ic_robo.3b606a7e.png";